import { Member } from "~/store";
import { useUserHome } from "./useUserHome";

export interface GroupMemberWithRole {
  member: Member;
  groupMembership: {
    role: string;
    joined_at: string;
    added_by_user_id: number;
  };
}

/**
 * Hook to access group members from the userHomeData in global state
 * This replaces the need for separate API calls to fetch group members
 */
export function useUserHomeMembers() {
  const { groupMembers, defaultGroup, isLoaded } = useUserHome();

  // Transform the data to match the expected format for the MembersCard component
  const formattedMembers: GroupMemberWithRole[] =
    groupMembers?.map((gm) => ({
      member: gm.member,
      groupMembership: {
        role: gm.role,
        joined_at: gm.joinedAt.toISOString(), // Convert Date to string
        added_by_user_id: gm.addedByUserId
      }
    })) || [];

  return {
    data: formattedMembers,
    isLoading: !isLoaded,
    error: undefined,
    defaultGroup
  };
}
